var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3365",
    "data-name": "Group 3365",
    xmlns: "http://www.w3.org/2000/svg",
    width: 170.582,
    height: 83.826,
    viewBox: "0 0 170.582 83.826",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M41.721,1.813a41.576,41.576,0,0,0-25.5,10.61c-.578.513.5,2.684-.047,3.236-.614.611-2.843-.4-3.416.248A41.578,41.578,0,0,0,2.333,41.2c-.044.814,1.569,1.631,1.569,2.457s-1.616,1.634-1.569,2.457a41.569,41.569,0,0,0,10.518,25.4,9.27,9.27,0,0,0,2.206,1.372,7.892,7.892,0,0,0,1.265,2.1A41.552,41.552,0,0,0,41.718,85.5a6.54,6.54,0,0,0,2.457-.953l1.637-39.312L44.2,2.491A8.177,8.177,0,0,0,41.721,1.813Z",
    transform: "translate(-2.262 -1.745)",
    fill: "#fdcb02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M16.518,3.348V75.379s1.643,10.17,2.457,10.117A41.578,41.578,0,0,0,44.447,74.91c.578-.522-.484-2.7.074-3.256.6-.608,2.829.41,3.392-.227a41.558,41.558,0,0,0,10.45-25.319c.047-.814-3.2-1.634-3.2-2.457s3.25-1.643,3.2-2.457A41.555,41.555,0,0,0,47.845,15.8a6.639,6.639,0,0,0-2.469-1.047,6.206,6.206,0,0,0-1.012-2.427A41.571,41.571,0,0,0,18.975,1.815C18.252,1.773,16.518,3.348,16.518,3.348Z",
    transform: "translate(25.395 -1.744)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M19.26,15.147,9.332,5.411C8.754,5.927,8.19,6.455,7.642,7q-.916.92-1.773,1.888l9.916,9.728Z",
    transform: "translate(4.634 5.269)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M15.686,25.473v13.9c.817.047,1.634.074,2.457.074h0l1.637-5.522-1.637-8.448Z",
    transform: "translate(23.773 44.381)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M18.975,25.473H16.518V39.445q1.234,0,2.457-.074Z",
    transform: "translate(25.395 44.381)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M15.686,1.864v13.9h2.457L19.78,7.84,18.143,1.79S16.5,1.814,15.686,1.864Z",
    transform: "translate(23.773 -1.79)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M18.975,1.864q-1.221-.075-2.457-.074V15.762h2.457Z",
    transform: "translate(25.395 -1.79)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M22.629,25.585l9.9,9.76q.867-.783,1.711-1.619.907-.907,1.752-1.864L26.1,22.11Z",
    transform: "translate(37.309 37.825)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M25.992,20.081h13.9c.047-.814.074-1.631.074-2.457s-.027-1.64-.074-2.457h-13.9Z",
    transform: "translate(43.865 24.289)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M16.28,15.167H2.382c-.044.817-.074,1.634-.074,2.457s.027,1.643.074,2.457h13.9Z",
    transform: "translate(-2.308 24.289)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M26.1,18.683l9.828-9.828q-.814-.916-1.684-1.787c-.581-.584-1.177-1.144-1.787-1.687l-9.828,9.828Z",
    transform: "translate(37.309 5.209)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M15.727,22.11,5.9,31.938q.814.916,1.684,1.787c.581.584,1.18,1.144,1.79,1.687L19.2,25.585Z",
    transform: "translate(4.693 37.825)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M36.676,5.694a30.4,30.4,0,1,0-.192,60.8h.192l1.64-28.973L36.676,5.694Z",
    transform: "translate(5.241 5.821)",
    fill: "#ffdf8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M46.917,36.092a30.43,30.43,0,0,0-30.4-30.4v60.8A30.432,30.432,0,0,0,46.917,36.092Z",
    transform: "translate(25.397 5.821)",
    fill: "#ffd664"
  })), /*#__PURE__*/React.createElement("g", {
    id: "M8s_white_background",
    "data-name": "M8s white background",
    transform: "translate(27.568 22.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4167",
    "data-name": "Path 4167",
    d: "M56.22,49.67a10.164,10.164,0,0,0-5.062-6.1c-.423-.244-.8-.568-1.308-.938,5.964-2.691,7.181-8.413,4.483-13.009-2.046-3.486-5.841-4.709-9.6-5.072a19.953,19.953,0,0,0-2.3-.088,23.54,23.54,0,0,0-5.922.882A11.482,11.482,0,0,0,30.96,28.8a8.727,8.727,0,0,0,3.633,13.689c-.289.332-.511.777-.867.963-4.695,2.43-6.455,6.163-5.311,11.354A10.6,10.6,0,0,0,34.253,62.1a16.636,16.636,0,0,0,8.173,1.676c.486-.007.977-.025,1.464-.053,4.218-.24,8.014-1.577,10.515-5.072C56.269,56.055,57.32,53.181,56.22,49.67ZM47,55.815a4.606,4.606,0,0,1-3.5.487c-.215-.065-.4-.12-.575-.159l-.1-.021a.275.275,0,0,0-.074-.014c-.042-.01-.081-.014-.123-.021a.529.529,0,0,0-.078-.007c-.039,0-.081-.007-.12-.007a.87.87,0,0,0-.1,0,1.088,1.088,0,0,0-.152.011c-.056.007-.117.014-.177.028a1.955,1.955,0,0,0-.254.065.078.078,0,0,0-.035.01c-.032.01-.065.021-.1.036-.091.035-.19.077-.3.13a3.057,3.057,0,0,1-3.883-.583,2.988,2.988,0,0,1,.165-4.116c1.429-1.676,2.967-3.259,4.833-5.284,1.831,2.149,3.372,3.976,4.931,5.789A2.3,2.3,0,0,1,47,55.815Zm-.173-19.271c-.155.2-.317.4-.483.6s-.332.389-.5.583c-1.03,1.166-2.18,2.3-3.411,3.609-.071.074-.138.148-.208.222-1.788-2.1-3.439-3.774-4.748-5.676a3.036,3.036,0,0,1,.194-4.2c1.273-1.214,2.691-.79,4.116-.272l.13.043a2.475,2.475,0,0,0,.286.049,1.549,1.549,0,0,0,.226,0,.865.865,0,0,0,.091-.006.9.9,0,0,0,.13-.021l.078-.021.084-.032c1.9-.842,3.517-.571,4.575.688C48.83,33.823,47.8,35.28,46.823,36.544Z",
    transform: "translate(-28.077 -24.461)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4168",
    "data-name": "Path 4168",
    d: "M254.025,130.126c-.156.2-.317.4-.483.6s-.332.389-.5.583c-1.03,1.166-2.18,2.3-3.411,3.609v-9.827a.87.87,0,0,0,.091-.006.9.9,0,0,0,.13-.021l.078-.021.084-.032c1.9-.842,3.517-.571,4.575.688C256.032,127.406,255,128.862,254.025,130.126Z",
    transform: "translate(-235.279 -118.043)",
    fill: "#cc2128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4169",
    "data-name": "Path 4169",
    d: "M254.217,372.023a4.606,4.606,0,0,1-3.5.487c-.215-.065-.4-.12-.575-.159-.035-.007-.065-.017-.1-.021a.272.272,0,0,0-.075-.014c-.042-.01-.081-.014-.123-.021a.517.517,0,0,0-.078-.007c-.039,0-.081-.007-.12-.007V362.57c1.831,2.149,3.372,3.976,4.931,5.789A2.3,2.3,0,0,1,254.217,372.023Z",
    transform: "translate(-235.298 -340.669)",
    fill: "#cc2128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4170",
    "data-name": "Path 4170",
    d: "M37.689,31.741a3.03,3.03,0,0,0-.194,4.2c1.308,1.9,2.96,3.573,4.748,5.675.07-.074.137-.148.208-.222v5.026c-1.866,2.025-3.4,3.609-4.833,5.284a2.989,2.989,0,0,0-.165,4.116,3.046,3.046,0,0,0,3.883.583c.106-.05.2-.092.3-.13.036-.014.065-.025.1-.036a.078.078,0,0,1,.035-.01,1.95,1.95,0,0,1,.254-.065c.06-.014.12-.021.177-.028a1.086,1.086,0,0,1,.152-.011.875.875,0,0,1,.1,0v7.706a16.636,16.636,0,0,1-8.173-1.676,10.588,10.588,0,0,1-5.841-7.29c-1.146-5.192.614-8.924,5.311-11.354.356-.183.578-.631.867-.963a8.727,8.727,0,0,1-3.636-13.69A11.482,11.482,0,0,1,36.525,25.4a23.541,23.541,0,0,1,5.922-.882v7.044a1.547,1.547,0,0,1-.226,0,2.48,2.48,0,0,1-.286-.049l-.13-.043C40.381,30.95,38.963,30.527,37.689,31.741Z",
    transform: "translate(-28.097 -24.516)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4171",
    "data-name": "Path 4171",
    d: "M56.22,49.67a10.164,10.164,0,0,0-5.062-6.1c-.423-.244-.8-.568-1.308-.938,5.964-2.691,7.181-8.413,4.483-13.009-2.046-3.486-5.841-4.709-9.6-5.072a19.953,19.953,0,0,0-2.3-.088,23.54,23.54,0,0,0-5.922.882A11.482,11.482,0,0,0,30.96,28.8a8.727,8.727,0,0,0,3.633,13.689c-.289.332-.511.777-.867.963-4.695,2.43-6.455,6.163-5.311,11.354A10.6,10.6,0,0,0,34.253,62.1a16.636,16.636,0,0,0,8.173,1.676c.486-.007.977-.025,1.464-.053,4.218-.24,8.014-1.577,10.515-5.072C56.269,56.055,57.32,53.181,56.22,49.67ZM47,55.815a4.606,4.606,0,0,1-3.5.487c-.215-.065-.4-.12-.575-.159-.035-.007-.065-.017-.1-.021a1.989,1.989,0,0,0-.275-.042c-.039,0-.081-.007-.12-.007a1.511,1.511,0,0,0-.431.033,1.954,1.954,0,0,0-.254.065,1.065,1.065,0,0,0-.176.065,2.346,2.346,0,0,0-.254.109,3.057,3.057,0,0,1-3.883-.583,2.988,2.988,0,0,1,.165-4.116c1.429-1.676,2.967-3.259,4.833-5.284C44.26,48.51,45.8,50.337,47.36,52.15A2.3,2.3,0,0,1,47,55.815Zm-.173-19.271c-.13.166-.259.335-.4.5-.233.286-.477.568-.727.847-.148.166-.3.328-.453.494-.183.2-.374.4-.568.607-.434.453-.882.917-1.344,1.4-.259.268-.522.547-.793.832-.039.039-.074.082-.113.12-.071.074-.138.148-.208.222-1.788-2.1-3.439-3.774-4.748-5.675a3.036,3.036,0,0,1,.194-4.2c1.273-1.214,2.691-.79,4.116-.272a1.658,1.658,0,0,0,.642.1.864.864,0,0,0,.091-.006.971.971,0,0,0,.293-.074c1.9-.842,3.517-.571,4.575.688C48.83,33.823,47.8,35.28,46.823,36.544Z",
    transform: "translate(-28.077 -24.461)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4172",
    "data-name": "Path 4172",
    d: "M254,130.126c-.129.17-.259.335-.4.5-.233.286-.477.568-.727.847-.148.166-.3.332-.454.494-.183.2-.374.4-.568.607-.434.453-.881.917-1.344,1.4-.259.272-.525.547-.794.832-.039.039-.074.082-.113.12v-9.829a.865.865,0,0,0,.091-.006.973.973,0,0,0,.293-.074c1.9-.842,3.517-.571,4.575.688C256,127.406,254.974,128.862,254,130.126Z",
    transform: "translate(-235.251 -118.043)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4173",
    "data-name": "Path 4173",
    d: "M254.217,372.023a4.606,4.606,0,0,1-3.5.487c-.215-.065-.4-.12-.575-.159-.035-.007-.065-.017-.1-.021a1.987,1.987,0,0,0-.275-.042c-.039,0-.081-.007-.12-.007V362.57c1.831,2.149,3.372,3.976,4.931,5.789A2.3,2.3,0,0,1,254.217,372.023Z",
    transform: "translate(-235.298 -340.669)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4174",
    "data-name": "Path 4174",
    d: "M166.727,362.57v9.711a1.517,1.517,0,0,0-.43.033,1.566,1.566,0,0,0-.254.065,1.077,1.077,0,0,0-.176.065,2.357,2.357,0,0,0-.254.109,3.056,3.056,0,0,1-3.883-.583,2.988,2.988,0,0,1,.165-4.116C163.324,366.179,164.861,364.595,166.727,362.57Z",
    transform: "translate(-152.377 -340.669)",
    fill: "#fdcb02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4175",
    "data-name": "Path 4175",
    d: "M167.267,124.472V134.3c-.071.074-.138.148-.208.222-1.788-2.1-3.439-3.774-4.748-5.676a3.036,3.036,0,0,1,.194-4.2c1.273-1.214,2.691-.79,4.116-.272A1.657,1.657,0,0,0,167.267,124.472Z",
    transform: "translate(-152.916 -117.425)",
    fill: "#fdcb02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4176",
    "data-name": "Path 4176",
    d: "M37.689,31.741a3.03,3.03,0,0,0-.194,4.2c1.308,1.9,2.96,3.573,4.748,5.675.07-.074.137-.148.208-.222v5.026c-1.866,2.025-3.4,3.609-4.833,5.284a2.989,2.989,0,0,0-.165,4.116,3.046,3.046,0,0,0,3.883.583,2.345,2.345,0,0,1,.254-.109,1.063,1.063,0,0,1,.176-.065,1.952,1.952,0,0,1,.254-.065,1.512,1.512,0,0,1,.431-.035v7.7a16.636,16.636,0,0,1-8.173-1.676,10.588,10.588,0,0,1-5.841-7.29c-1.146-5.192.614-8.924,5.311-11.354.356-.183.578-.631.867-.963a8.727,8.727,0,0,1-3.636-13.69A11.482,11.482,0,0,1,36.525,25.4a23.541,23.541,0,0,1,5.922-.882v7.044a1.657,1.657,0,0,1-.642-.1C40.381,30.95,38.963,30.527,37.689,31.741Z",
    transform: "translate(-28.097 -24.516)",
    fill: "#fdae02"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3123",
    "data-name": "Group 3123",
    transform: "translate(44.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76-2",
    "data-name": "Group 76",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29-2",
    "data-name": "Path 29",
    d: "M41.721,1.813a41.576,41.576,0,0,0-25.5,10.61c-.578.513.5,2.684-.047,3.236-.614.611-2.843-.4-3.416.248A41.578,41.578,0,0,0,2.333,41.2c-.044.814,1.569,1.631,1.569,2.457s-1.616,1.634-1.569,2.457a41.569,41.569,0,0,0,10.518,25.4,9.27,9.27,0,0,0,2.206,1.372,7.892,7.892,0,0,0,1.265,2.1A41.552,41.552,0,0,0,41.718,85.5a6.54,6.54,0,0,0,2.457-.953l1.637-39.312L44.2,2.491A8.177,8.177,0,0,0,41.721,1.813Z",
    transform: "translate(-2.262 -1.745)",
    fill: "#fdcb02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-2",
    "data-name": "Path 30",
    d: "M16.518,3.348V75.379s1.643,10.17,2.457,10.117A41.578,41.578,0,0,0,44.447,74.91c.578-.522-.484-2.7.074-3.256.6-.608,2.829.41,3.392-.227a41.558,41.558,0,0,0,10.45-25.319c.047-.814-3.2-1.634-3.2-2.457s3.25-1.643,3.2-2.457A41.555,41.555,0,0,0,47.845,15.8a6.639,6.639,0,0,0-2.469-1.047,6.206,6.206,0,0,0-1.012-2.427A41.571,41.571,0,0,0,18.975,1.815C18.252,1.773,16.518,3.348,16.518,3.348Z",
    transform: "translate(25.395 -1.744)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-2",
    "data-name": "Path 31",
    d: "M19.26,15.147,9.332,5.411C8.754,5.927,8.19,6.455,7.642,7q-.916.92-1.773,1.888l9.916,9.728Z",
    transform: "translate(4.634 5.269)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-2",
    "data-name": "Path 32",
    d: "M15.686,25.473v13.9c.817.047,1.634.074,2.457.074h0l1.637-5.522-1.637-8.448Z",
    transform: "translate(23.773 44.381)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33-2",
    "data-name": "Path 33",
    d: "M18.975,25.473H16.518V39.445q1.234,0,2.457-.074Z",
    transform: "translate(25.395 44.381)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34-2",
    "data-name": "Path 34",
    d: "M15.686,1.864v13.9h2.457L19.78,7.84,18.143,1.79S16.5,1.814,15.686,1.864Z",
    transform: "translate(23.773 -1.79)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35-2",
    "data-name": "Path 35",
    d: "M18.975,1.864q-1.221-.075-2.457-.074V15.762h2.457Z",
    transform: "translate(25.395 -1.79)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36-2",
    "data-name": "Path 36",
    d: "M22.629,25.585l9.9,9.76q.867-.783,1.711-1.619.907-.907,1.752-1.864L26.1,22.11Z",
    transform: "translate(37.309 37.825)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37-2",
    "data-name": "Path 37",
    d: "M25.992,20.081h13.9c.047-.814.074-1.631.074-2.457s-.027-1.64-.074-2.457h-13.9Z",
    transform: "translate(43.865 24.289)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38-2",
    "data-name": "Path 38",
    d: "M16.28,15.167H2.382c-.044.817-.074,1.634-.074,2.457s.027,1.643.074,2.457h13.9Z",
    transform: "translate(-2.308 24.289)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39-2",
    "data-name": "Path 39",
    d: "M26.1,18.683l9.828-9.828q-.814-.916-1.684-1.787c-.581-.584-1.177-1.144-1.787-1.687l-9.828,9.828Z",
    transform: "translate(37.309 5.209)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40-2",
    "data-name": "Path 40",
    d: "M15.727,22.11,5.9,31.938q.814.916,1.684,1.787c.581.584,1.18,1.144,1.79,1.687L19.2,25.585Z",
    transform: "translate(4.693 37.825)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41-2",
    "data-name": "Path 41",
    d: "M36.676,5.694a30.4,30.4,0,1,0-.192,60.8h.192l1.64-28.973L36.676,5.694Z",
    transform: "translate(5.241 5.821)",
    fill: "#ffdf8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42-2",
    "data-name": "Path 42",
    d: "M46.917,36.092a30.43,30.43,0,0,0-30.4-30.4v60.8A30.432,30.432,0,0,0,46.917,36.092Z",
    transform: "translate(25.397 5.821)",
    fill: "#ffd664"
  })), /*#__PURE__*/React.createElement("g", {
    id: "M8s_white_background-2",
    "data-name": "M8s white background",
    transform: "translate(27.568 22.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4167-2",
    "data-name": "Path 4167",
    d: "M56.22,49.67a10.164,10.164,0,0,0-5.062-6.1c-.423-.244-.8-.568-1.308-.938,5.964-2.691,7.181-8.413,4.483-13.009-2.046-3.486-5.841-4.709-9.6-5.072a19.953,19.953,0,0,0-2.3-.088,23.54,23.54,0,0,0-5.922.882A11.482,11.482,0,0,0,30.96,28.8a8.727,8.727,0,0,0,3.633,13.689c-.289.332-.511.777-.867.963-4.695,2.43-6.455,6.163-5.311,11.354A10.6,10.6,0,0,0,34.253,62.1a16.636,16.636,0,0,0,8.173,1.676c.486-.007.977-.025,1.464-.053,4.218-.24,8.014-1.577,10.515-5.072C56.269,56.055,57.32,53.181,56.22,49.67ZM47,55.815a4.606,4.606,0,0,1-3.5.487c-.215-.065-.4-.12-.575-.159l-.1-.021a.275.275,0,0,0-.074-.014c-.042-.01-.081-.014-.123-.021a.529.529,0,0,0-.078-.007c-.039,0-.081-.007-.12-.007a.87.87,0,0,0-.1,0,1.088,1.088,0,0,0-.152.011c-.056.007-.117.014-.177.028a1.955,1.955,0,0,0-.254.065.078.078,0,0,0-.035.01c-.032.01-.065.021-.1.036-.091.035-.19.077-.3.13a3.057,3.057,0,0,1-3.883-.583,2.988,2.988,0,0,1,.165-4.116c1.429-1.676,2.967-3.259,4.833-5.284,1.831,2.149,3.372,3.976,4.931,5.789A2.3,2.3,0,0,1,47,55.815Zm-.173-19.271c-.155.2-.317.4-.483.6s-.332.389-.5.583c-1.03,1.166-2.18,2.3-3.411,3.609-.071.074-.138.148-.208.222-1.788-2.1-3.439-3.774-4.748-5.676a3.036,3.036,0,0,1,.194-4.2c1.273-1.214,2.691-.79,4.116-.272l.13.043a2.475,2.475,0,0,0,.286.049,1.549,1.549,0,0,0,.226,0,.865.865,0,0,0,.091-.006.9.9,0,0,0,.13-.021l.078-.021.084-.032c1.9-.842,3.517-.571,4.575.688C48.83,33.823,47.8,35.28,46.823,36.544Z",
    transform: "translate(-28.077 -24.461)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4168-2",
    "data-name": "Path 4168",
    d: "M254.025,130.126c-.156.2-.317.4-.483.6s-.332.389-.5.583c-1.03,1.166-2.18,2.3-3.411,3.609v-9.827a.87.87,0,0,0,.091-.006.9.9,0,0,0,.13-.021l.078-.021.084-.032c1.9-.842,3.517-.571,4.575.688C256.032,127.406,255,128.862,254.025,130.126Z",
    transform: "translate(-235.279 -118.043)",
    fill: "#cc2128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4169-2",
    "data-name": "Path 4169",
    d: "M254.217,372.023a4.606,4.606,0,0,1-3.5.487c-.215-.065-.4-.12-.575-.159-.035-.007-.065-.017-.1-.021a.272.272,0,0,0-.075-.014c-.042-.01-.081-.014-.123-.021a.517.517,0,0,0-.078-.007c-.039,0-.081-.007-.12-.007V362.57c1.831,2.149,3.372,3.976,4.931,5.789A2.3,2.3,0,0,1,254.217,372.023Z",
    transform: "translate(-235.298 -340.669)",
    fill: "#cc2128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4170-2",
    "data-name": "Path 4170",
    d: "M37.689,31.741a3.03,3.03,0,0,0-.194,4.2c1.308,1.9,2.96,3.573,4.748,5.675.07-.074.137-.148.208-.222v5.026c-1.866,2.025-3.4,3.609-4.833,5.284a2.989,2.989,0,0,0-.165,4.116,3.046,3.046,0,0,0,3.883.583c.106-.05.2-.092.3-.13.036-.014.065-.025.1-.036a.078.078,0,0,1,.035-.01,1.95,1.95,0,0,1,.254-.065c.06-.014.12-.021.177-.028a1.086,1.086,0,0,1,.152-.011.875.875,0,0,1,.1,0v7.706a16.636,16.636,0,0,1-8.173-1.676,10.588,10.588,0,0,1-5.841-7.29c-1.146-5.192.614-8.924,5.311-11.354.356-.183.578-.631.867-.963a8.727,8.727,0,0,1-3.636-13.69A11.482,11.482,0,0,1,36.525,25.4a23.541,23.541,0,0,1,5.922-.882v7.044a1.547,1.547,0,0,1-.226,0,2.48,2.48,0,0,1-.286-.049l-.13-.043C40.381,30.95,38.963,30.527,37.689,31.741Z",
    transform: "translate(-28.097 -24.516)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4171-2",
    "data-name": "Path 4171",
    d: "M56.22,49.67a10.164,10.164,0,0,0-5.062-6.1c-.423-.244-.8-.568-1.308-.938,5.964-2.691,7.181-8.413,4.483-13.009-2.046-3.486-5.841-4.709-9.6-5.072a19.953,19.953,0,0,0-2.3-.088,23.54,23.54,0,0,0-5.922.882A11.482,11.482,0,0,0,30.96,28.8a8.727,8.727,0,0,0,3.633,13.689c-.289.332-.511.777-.867.963-4.695,2.43-6.455,6.163-5.311,11.354A10.6,10.6,0,0,0,34.253,62.1a16.636,16.636,0,0,0,8.173,1.676c.486-.007.977-.025,1.464-.053,4.218-.24,8.014-1.577,10.515-5.072C56.269,56.055,57.32,53.181,56.22,49.67ZM47,55.815a4.606,4.606,0,0,1-3.5.487c-.215-.065-.4-.12-.575-.159-.035-.007-.065-.017-.1-.021a1.989,1.989,0,0,0-.275-.042c-.039,0-.081-.007-.12-.007a1.511,1.511,0,0,0-.431.033,1.954,1.954,0,0,0-.254.065,1.065,1.065,0,0,0-.176.065,2.346,2.346,0,0,0-.254.109,3.057,3.057,0,0,1-3.883-.583,2.988,2.988,0,0,1,.165-4.116c1.429-1.676,2.967-3.259,4.833-5.284C44.26,48.51,45.8,50.337,47.36,52.15A2.3,2.3,0,0,1,47,55.815Zm-.173-19.271c-.13.166-.259.335-.4.5-.233.286-.477.568-.727.847-.148.166-.3.328-.453.494-.183.2-.374.4-.568.607-.434.453-.882.917-1.344,1.4-.259.268-.522.547-.793.832-.039.039-.074.082-.113.12-.071.074-.138.148-.208.222-1.788-2.1-3.439-3.774-4.748-5.675a3.036,3.036,0,0,1,.194-4.2c1.273-1.214,2.691-.79,4.116-.272a1.658,1.658,0,0,0,.642.1.864.864,0,0,0,.091-.006.971.971,0,0,0,.293-.074c1.9-.842,3.517-.571,4.575.688C48.83,33.823,47.8,35.28,46.823,36.544Z",
    transform: "translate(-28.077 -24.461)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4172-2",
    "data-name": "Path 4172",
    d: "M254,130.126c-.129.17-.259.335-.4.5-.233.286-.477.568-.727.847-.148.166-.3.332-.454.494-.183.2-.374.4-.568.607-.434.453-.881.917-1.344,1.4-.259.272-.525.547-.794.832-.039.039-.074.082-.113.12v-9.829a.865.865,0,0,0,.091-.006.973.973,0,0,0,.293-.074c1.9-.842,3.517-.571,4.575.688C256,127.406,254.974,128.862,254,130.126Z",
    transform: "translate(-235.251 -118.043)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4173-2",
    "data-name": "Path 4173",
    d: "M254.217,372.023a4.606,4.606,0,0,1-3.5.487c-.215-.065-.4-.12-.575-.159-.035-.007-.065-.017-.1-.021a1.987,1.987,0,0,0-.275-.042c-.039,0-.081-.007-.12-.007V362.57c1.831,2.149,3.372,3.976,4.931,5.789A2.3,2.3,0,0,1,254.217,372.023Z",
    transform: "translate(-235.298 -340.669)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4174-2",
    "data-name": "Path 4174",
    d: "M166.727,362.57v9.711a1.517,1.517,0,0,0-.43.033,1.566,1.566,0,0,0-.254.065,1.077,1.077,0,0,0-.176.065,2.357,2.357,0,0,0-.254.109,3.056,3.056,0,0,1-3.883-.583,2.988,2.988,0,0,1,.165-4.116C163.324,366.179,164.861,364.595,166.727,362.57Z",
    transform: "translate(-152.377 -340.669)",
    fill: "#fdcb02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4175-2",
    "data-name": "Path 4175",
    d: "M167.267,124.472V134.3c-.071.074-.138.148-.208.222-1.788-2.1-3.439-3.774-4.748-5.676a3.036,3.036,0,0,1,.194-4.2c1.273-1.214,2.691-.79,4.116-.272A1.657,1.657,0,0,0,167.267,124.472Z",
    transform: "translate(-152.916 -117.425)",
    fill: "#fdcb02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4176-2",
    "data-name": "Path 4176",
    d: "M37.689,31.741a3.03,3.03,0,0,0-.194,4.2c1.308,1.9,2.96,3.573,4.748,5.675.07-.074.137-.148.208-.222v5.026c-1.866,2.025-3.4,3.609-4.833,5.284a2.989,2.989,0,0,0-.165,4.116,3.046,3.046,0,0,0,3.883.583,2.345,2.345,0,0,1,.254-.109,1.063,1.063,0,0,1,.176-.065,1.952,1.952,0,0,1,.254-.065,1.512,1.512,0,0,1,.431-.035v7.7a16.636,16.636,0,0,1-8.173-1.676,10.588,10.588,0,0,1-5.841-7.29c-1.146-5.192.614-8.924,5.311-11.354.356-.183.578-.631.867-.963a8.727,8.727,0,0,1-3.636-13.69A11.482,11.482,0,0,1,36.525,25.4a23.541,23.541,0,0,1,5.922-.882v7.044a1.657,1.657,0,0,1-.642-.1C40.381,30.95,38.963,30.527,37.689,31.741Z",
    transform: "translate(-28.097 -24.516)",
    fill: "#fdae02"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3124",
    "data-name": "Group 3124",
    transform: "translate(86.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76-3",
    "data-name": "Group 76",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29-3",
    "data-name": "Path 29",
    d: "M41.721,1.813a41.576,41.576,0,0,0-25.5,10.61c-.578.513.5,2.684-.047,3.236-.614.611-2.843-.4-3.416.248A41.578,41.578,0,0,0,2.333,41.2c-.044.814,1.569,1.631,1.569,2.457s-1.616,1.634-1.569,2.457a41.569,41.569,0,0,0,10.518,25.4,9.27,9.27,0,0,0,2.206,1.372,7.892,7.892,0,0,0,1.265,2.1A41.552,41.552,0,0,0,41.718,85.5a6.54,6.54,0,0,0,2.457-.953l1.637-39.312L44.2,2.491A8.177,8.177,0,0,0,41.721,1.813Z",
    transform: "translate(-2.262 -1.745)",
    fill: "#fdcb02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-3",
    "data-name": "Path 30",
    d: "M16.518,3.348V75.379s1.643,10.17,2.457,10.117A41.578,41.578,0,0,0,44.447,74.91c.578-.522-.484-2.7.074-3.256.6-.608,2.829.41,3.392-.227a41.558,41.558,0,0,0,10.45-25.319c.047-.814-3.2-1.634-3.2-2.457s3.25-1.643,3.2-2.457A41.555,41.555,0,0,0,47.845,15.8a6.639,6.639,0,0,0-2.469-1.047,6.206,6.206,0,0,0-1.012-2.427A41.571,41.571,0,0,0,18.975,1.815C18.252,1.773,16.518,3.348,16.518,3.348Z",
    transform: "translate(25.395 -1.744)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-3",
    "data-name": "Path 31",
    d: "M19.26,15.147,9.332,5.411C8.754,5.927,8.19,6.455,7.642,7q-.916.92-1.773,1.888l9.916,9.728Z",
    transform: "translate(4.634 5.269)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-3",
    "data-name": "Path 32",
    d: "M15.686,25.473v13.9c.817.047,1.634.074,2.457.074h0l1.637-5.522-1.637-8.448Z",
    transform: "translate(23.773 44.381)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33-3",
    "data-name": "Path 33",
    d: "M18.975,25.473H16.518V39.445q1.234,0,2.457-.074Z",
    transform: "translate(25.395 44.381)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34-3",
    "data-name": "Path 34",
    d: "M15.686,1.864v13.9h2.457L19.78,7.84,18.143,1.79S16.5,1.814,15.686,1.864Z",
    transform: "translate(23.773 -1.79)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35-3",
    "data-name": "Path 35",
    d: "M18.975,1.864q-1.221-.075-2.457-.074V15.762h2.457Z",
    transform: "translate(25.395 -1.79)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36-3",
    "data-name": "Path 36",
    d: "M22.629,25.585l9.9,9.76q.867-.783,1.711-1.619.907-.907,1.752-1.864L26.1,22.11Z",
    transform: "translate(37.309 37.825)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37-3",
    "data-name": "Path 37",
    d: "M25.992,20.081h13.9c.047-.814.074-1.631.074-2.457s-.027-1.64-.074-2.457h-13.9Z",
    transform: "translate(43.865 24.289)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38-3",
    "data-name": "Path 38",
    d: "M16.28,15.167H2.382c-.044.817-.074,1.634-.074,2.457s.027,1.643.074,2.457h13.9Z",
    transform: "translate(-2.308 24.289)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39-3",
    "data-name": "Path 39",
    d: "M26.1,18.683l9.828-9.828q-.814-.916-1.684-1.787c-.581-.584-1.177-1.144-1.787-1.687l-9.828,9.828Z",
    transform: "translate(37.309 5.209)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40-3",
    "data-name": "Path 40",
    d: "M15.727,22.11,5.9,31.938q.814.916,1.684,1.787c.581.584,1.18,1.144,1.79,1.687L19.2,25.585Z",
    transform: "translate(4.693 37.825)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41-3",
    "data-name": "Path 41",
    d: "M36.676,5.694a30.4,30.4,0,1,0-.192,60.8h.192l1.64-28.973L36.676,5.694Z",
    transform: "translate(5.241 5.821)",
    fill: "#ffdf8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42-3",
    "data-name": "Path 42",
    d: "M46.917,36.092a30.43,30.43,0,0,0-30.4-30.4v60.8A30.432,30.432,0,0,0,46.917,36.092Z",
    transform: "translate(25.397 5.821)",
    fill: "#ffd664"
  })), /*#__PURE__*/React.createElement("g", {
    id: "M8s_white_background-3",
    "data-name": "M8s white background",
    transform: "translate(27.568 22.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4167-3",
    "data-name": "Path 4167",
    d: "M56.22,49.67a10.164,10.164,0,0,0-5.062-6.1c-.423-.244-.8-.568-1.308-.938,5.964-2.691,7.181-8.413,4.483-13.009-2.046-3.486-5.841-4.709-9.6-5.072a19.953,19.953,0,0,0-2.3-.088,23.54,23.54,0,0,0-5.922.882A11.482,11.482,0,0,0,30.96,28.8a8.727,8.727,0,0,0,3.633,13.689c-.289.332-.511.777-.867.963-4.695,2.43-6.455,6.163-5.311,11.354A10.6,10.6,0,0,0,34.253,62.1a16.636,16.636,0,0,0,8.173,1.676c.486-.007.977-.025,1.464-.053,4.218-.24,8.014-1.577,10.515-5.072C56.269,56.055,57.32,53.181,56.22,49.67ZM47,55.815a4.606,4.606,0,0,1-3.5.487c-.215-.065-.4-.12-.575-.159l-.1-.021a.275.275,0,0,0-.074-.014c-.042-.01-.081-.014-.123-.021a.529.529,0,0,0-.078-.007c-.039,0-.081-.007-.12-.007a.87.87,0,0,0-.1,0,1.088,1.088,0,0,0-.152.011c-.056.007-.117.014-.177.028a1.955,1.955,0,0,0-.254.065.078.078,0,0,0-.035.01c-.032.01-.065.021-.1.036-.091.035-.19.077-.3.13a3.057,3.057,0,0,1-3.883-.583,2.988,2.988,0,0,1,.165-4.116c1.429-1.676,2.967-3.259,4.833-5.284,1.831,2.149,3.372,3.976,4.931,5.789A2.3,2.3,0,0,1,47,55.815Zm-.173-19.271c-.155.2-.317.4-.483.6s-.332.389-.5.583c-1.03,1.166-2.18,2.3-3.411,3.609-.071.074-.138.148-.208.222-1.788-2.1-3.439-3.774-4.748-5.676a3.036,3.036,0,0,1,.194-4.2c1.273-1.214,2.691-.79,4.116-.272l.13.043a2.475,2.475,0,0,0,.286.049,1.549,1.549,0,0,0,.226,0,.865.865,0,0,0,.091-.006.9.9,0,0,0,.13-.021l.078-.021.084-.032c1.9-.842,3.517-.571,4.575.688C48.83,33.823,47.8,35.28,46.823,36.544Z",
    transform: "translate(-28.077 -24.461)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4168-3",
    "data-name": "Path 4168",
    d: "M254.025,130.126c-.156.2-.317.4-.483.6s-.332.389-.5.583c-1.03,1.166-2.18,2.3-3.411,3.609v-9.827a.87.87,0,0,0,.091-.006.9.9,0,0,0,.13-.021l.078-.021.084-.032c1.9-.842,3.517-.571,4.575.688C256.032,127.406,255,128.862,254.025,130.126Z",
    transform: "translate(-235.279 -118.043)",
    fill: "#cc2128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4169-3",
    "data-name": "Path 4169",
    d: "M254.217,372.023a4.606,4.606,0,0,1-3.5.487c-.215-.065-.4-.12-.575-.159-.035-.007-.065-.017-.1-.021a.272.272,0,0,0-.075-.014c-.042-.01-.081-.014-.123-.021a.517.517,0,0,0-.078-.007c-.039,0-.081-.007-.12-.007V362.57c1.831,2.149,3.372,3.976,4.931,5.789A2.3,2.3,0,0,1,254.217,372.023Z",
    transform: "translate(-235.298 -340.669)",
    fill: "#cc2128"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4170-3",
    "data-name": "Path 4170",
    d: "M37.689,31.741a3.03,3.03,0,0,0-.194,4.2c1.308,1.9,2.96,3.573,4.748,5.675.07-.074.137-.148.208-.222v5.026c-1.866,2.025-3.4,3.609-4.833,5.284a2.989,2.989,0,0,0-.165,4.116,3.046,3.046,0,0,0,3.883.583c.106-.05.2-.092.3-.13.036-.014.065-.025.1-.036a.078.078,0,0,1,.035-.01,1.95,1.95,0,0,1,.254-.065c.06-.014.12-.021.177-.028a1.086,1.086,0,0,1,.152-.011.875.875,0,0,1,.1,0v7.706a16.636,16.636,0,0,1-8.173-1.676,10.588,10.588,0,0,1-5.841-7.29c-1.146-5.192.614-8.924,5.311-11.354.356-.183.578-.631.867-.963a8.727,8.727,0,0,1-3.636-13.69A11.482,11.482,0,0,1,36.525,25.4a23.541,23.541,0,0,1,5.922-.882v7.044a1.547,1.547,0,0,1-.226,0,2.48,2.48,0,0,1-.286-.049l-.13-.043C40.381,30.95,38.963,30.527,37.689,31.741Z",
    transform: "translate(-28.097 -24.516)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4171-3",
    "data-name": "Path 4171",
    d: "M56.22,49.67a10.164,10.164,0,0,0-5.062-6.1c-.423-.244-.8-.568-1.308-.938,5.964-2.691,7.181-8.413,4.483-13.009-2.046-3.486-5.841-4.709-9.6-5.072a19.953,19.953,0,0,0-2.3-.088,23.54,23.54,0,0,0-5.922.882A11.482,11.482,0,0,0,30.96,28.8a8.727,8.727,0,0,0,3.633,13.689c-.289.332-.511.777-.867.963-4.695,2.43-6.455,6.163-5.311,11.354A10.6,10.6,0,0,0,34.253,62.1a16.636,16.636,0,0,0,8.173,1.676c.486-.007.977-.025,1.464-.053,4.218-.24,8.014-1.577,10.515-5.072C56.269,56.055,57.32,53.181,56.22,49.67ZM47,55.815a4.606,4.606,0,0,1-3.5.487c-.215-.065-.4-.12-.575-.159-.035-.007-.065-.017-.1-.021a1.989,1.989,0,0,0-.275-.042c-.039,0-.081-.007-.12-.007a1.511,1.511,0,0,0-.431.033,1.954,1.954,0,0,0-.254.065,1.065,1.065,0,0,0-.176.065,2.346,2.346,0,0,0-.254.109,3.057,3.057,0,0,1-3.883-.583,2.988,2.988,0,0,1,.165-4.116c1.429-1.676,2.967-3.259,4.833-5.284C44.26,48.51,45.8,50.337,47.36,52.15A2.3,2.3,0,0,1,47,55.815Zm-.173-19.271c-.13.166-.259.335-.4.5-.233.286-.477.568-.727.847-.148.166-.3.328-.453.494-.183.2-.374.4-.568.607-.434.453-.882.917-1.344,1.4-.259.268-.522.547-.793.832-.039.039-.074.082-.113.12-.071.074-.138.148-.208.222-1.788-2.1-3.439-3.774-4.748-5.675a3.036,3.036,0,0,1,.194-4.2c1.273-1.214,2.691-.79,4.116-.272a1.658,1.658,0,0,0,.642.1.864.864,0,0,0,.091-.006.971.971,0,0,0,.293-.074c1.9-.842,3.517-.571,4.575.688C48.83,33.823,47.8,35.28,46.823,36.544Z",
    transform: "translate(-28.077 -24.461)",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4172-3",
    "data-name": "Path 4172",
    d: "M254,130.126c-.129.17-.259.335-.4.5-.233.286-.477.568-.727.847-.148.166-.3.332-.454.494-.183.2-.374.4-.568.607-.434.453-.881.917-1.344,1.4-.259.272-.525.547-.794.832-.039.039-.074.082-.113.12v-9.829a.865.865,0,0,0,.091-.006.973.973,0,0,0,.293-.074c1.9-.842,3.517-.571,4.575.688C256,127.406,254.974,128.862,254,130.126Z",
    transform: "translate(-235.251 -118.043)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4173-3",
    "data-name": "Path 4173",
    d: "M254.217,372.023a4.606,4.606,0,0,1-3.5.487c-.215-.065-.4-.12-.575-.159-.035-.007-.065-.017-.1-.021a1.987,1.987,0,0,0-.275-.042c-.039,0-.081-.007-.12-.007V362.57c1.831,2.149,3.372,3.976,4.931,5.789A2.3,2.3,0,0,1,254.217,372.023Z",
    transform: "translate(-235.298 -340.669)",
    fill: "#fdae02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4174-3",
    "data-name": "Path 4174",
    d: "M166.727,362.57v9.711a1.517,1.517,0,0,0-.43.033,1.566,1.566,0,0,0-.254.065,1.077,1.077,0,0,0-.176.065,2.357,2.357,0,0,0-.254.109,3.056,3.056,0,0,1-3.883-.583,2.988,2.988,0,0,1,.165-4.116C163.324,366.179,164.861,364.595,166.727,362.57Z",
    transform: "translate(-152.377 -340.669)",
    fill: "#fdcb02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4175-3",
    "data-name": "Path 4175",
    d: "M167.267,124.472V134.3c-.071.074-.138.148-.208.222-1.788-2.1-3.439-3.774-4.748-5.676a3.036,3.036,0,0,1,.194-4.2c1.273-1.214,2.691-.79,4.116-.272A1.657,1.657,0,0,0,167.267,124.472Z",
    transform: "translate(-152.916 -117.425)",
    fill: "#fdcb02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4176-3",
    "data-name": "Path 4176",
    d: "M37.689,31.741a3.03,3.03,0,0,0-.194,4.2c1.308,1.9,2.96,3.573,4.748,5.675.07-.074.137-.148.208-.222v5.026c-1.866,2.025-3.4,3.609-4.833,5.284a2.989,2.989,0,0,0-.165,4.116,3.046,3.046,0,0,0,3.883.583,2.345,2.345,0,0,1,.254-.109,1.063,1.063,0,0,1,.176-.065,1.952,1.952,0,0,1,.254-.065,1.512,1.512,0,0,1,.431-.035v7.7a16.636,16.636,0,0,1-8.173-1.676,10.588,10.588,0,0,1-5.841-7.29c-1.146-5.192.614-8.924,5.311-11.354.356-.183.578-.631.867-.963a8.727,8.727,0,0,1-3.636-13.69A11.482,11.482,0,0,1,36.525,25.4a23.541,23.541,0,0,1,5.922-.882v7.044a1.657,1.657,0,0,1-.642-.1C40.381,30.95,38.963,30.527,37.689,31.741Z",
    transform: "translate(-28.097 -24.516)",
    fill: "#fdae02"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.509aee05899bcdac0b44bb59e8a621ed.svg";
export { ForwardRef as ReactComponent };